import { appConfig, headerConfig, refineHeader } from "../../config";

export const affiliateService = {
  add_affiliate,
  getCust_SalesManagerList,
  getAffiliateList,
  deleteAffiliate,
  getAffiliateDetails,
  update_affiliate,
  getAffiliateDashboard,
  getAffiliateDashboardByUser
};

function add_affiliate(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}affiliate/addAffiliate`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAffiliateList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}affiliate/list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getCust_SalesManagerList() {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}user/customer-salesmanager-list`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAffiliateDashboard(affiliateIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}affiliate/dashboard/${affiliateIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAffiliateDashboardByUser(userIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}affiliate/affiliate-dashboard/${userIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function deleteAffiliate(affiliateIdAsParam) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(
    `${appConfig.api.url}affiliate/delete/${affiliateIdAsParam}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAffiliateDetails(affiliateIdParams) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}affiliate/detail/${affiliateIdParams}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update_affiliate(postData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}affiliate/edit`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/affiliateService.js